// src/plugins/posthog.js
import posthog from 'posthog-js';
export function setupPostHog() {
  posthog.init('phc_xrt4sXuAeIEzegrR4kfBqr2WVEJ7RsCUSD3Qci8L5V4', {
    api_host: 'https://posthog.shiryu.cc',
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  })

  posthog.register({
    'platform': '8',  // 自定义键值对
  })

  window.posthog = posthog;
}
